import Vue from 'vue';
import axios from 'axios';
import {
  BAN_POST,
  UNBAN_POST,
  FETCH_POSTS_PENDING_FAILED,
  FETCH_POSTS_PENDING_SUCCESS,
  TOGGLE_SPINNER,
} from '../mutation-types';

export const state = {
  all: [],
  isLoading: false,
};

export const mutations = {
  [FETCH_POSTS_PENDING_SUCCESS](state, posts) {
    state.all = posts;
  },

  [FETCH_POSTS_PENDING_FAILED](state) {
    state.all = [];
  },

  [BAN_POST](state, post) {
    let index = state.all.indexOf(post);
    state.all.splice(index, 1);
  },

  [UNBAN_POST](state, post) {
    let index = state.all.indexOf(post);
    state.all.splice(index, 1);
  },

  [TOGGLE_SPINNER](state) {
    state.isLoading = !state.isLoading;
  },
};

export const actions = {
  async fetch({ commit }) {
    try {
      const { data: { data } } = await axios.get('/api/pending/posts');
      commit(FETCH_POSTS_PENDING_SUCCESS, data);
    } catch (e) {
      commit(FETCH_POSTS_PENDING_FAILED);
    }
  },

  async ban({ dispatch, commit }, post) {
    try {
      dispatch('toggleSpinner');

      await axios.patch(`/api/posts/${post.id}/ban`);
      commit(BAN_POST, post);

      dispatch('toast', 'Post flagged.', { root: true });
    } catch(e) {
      dispatch('toast', {
        message: 'Something went wrong.',
        type: 'is-danger'
      }, { root: true });
    } finally {
      dispatch('toggleSpinner');
    }
  },

  async unban({ dispatch, commit }, post) {
    try {
      dispatch('toggleSpinner');

      await axios.patch(`/api/posts/${post.id}/unban`);
      commit(UNBAN_POST, post);

      dispatch('toast', 'Post unflagged.', { root: true });
    } catch(e) {
      dispatch('toast', {
        message: 'Something went wrong.',
        type: 'is-danger'
      }, { root: true });
    } finally {
      dispatch('toggleSpinner');
    }
  },

  toggleSpinner({ commit }) {
    commit(TOGGLE_SPINNER);
  },
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/postspending.js